import React from 'react'
import { Box, CloseIconWMO } from '@usap/uicomponents'
import { 
  ModalContainer,
  HeadingSection, 
  Heading, 
  SubHeading, 
  CTAWrapper,
  CancelCTA, 
  ContinueCTA, 
  CloseCTA
} from "./style/CancelReturnWMO.css"
import getConfig from '@usap/carparts/src/config/getConfig'

const config=getConfig()
const specialPhoneNumber=config?.common?.carbTextIndexIndicator?.specialPhoneNumber

const CancelReturnWMO = ({ onCancelReturn, setDisplayCancel }) => (
  <ModalContainer
    fadeIn
  >
    <HeadingSection>
      <Heading>
        Cancel Return?
      </Heading>
      <CloseCTA
        type="button" 
        onClick={() => setDisplayCancel(false)}
      >
        <CloseIconWMO />
      </CloseCTA>
    </HeadingSection>
    <SubHeading>
    <span>Are you sure you want to cancel your return? Your information will not be saved.</span>
    <span>Need help? Contact our customer service team at {specialPhoneNumber}. </span>
    </SubHeading>
    <CTAWrapper>
      <CancelCTA
        onClick={onCancelReturn}
        type="submit"
      >
        Yes, Cancel Return
      </CancelCTA>
      <ContinueCTA
        onClick={() => setDisplayCancel(false)}
        type='button'
      >
        No, Continue Return Process
      </ContinueCTA>
    </CTAWrapper>
  </ModalContainer>
)

export default CancelReturnWMO
